import {
    ChampionshipReigns,
    Companies,
    MatchContracts,
    Matches, Properties,
    RandomEvents,
    Superstars,
    Tournaments
} from "./models.js";

function Championship(name, vacated = false, tagTeam = false) {

    // Strings
    const rank = null;
    const gender = 'male';
    const prestige = 'C';
    const highestPrestige = 'C';
    const brandName = null;
    const objectName = 'championship';

    // Integer
    const monthsToExpire = null;
    const xp = 0;
    const xpGainedThisYear = 0;

    // Boolean
    const booked = false;
    const trio = false;
    const championshipContract = false;
    const matchContract = false;
    const retired = false;

    // Foreign keys
    const superstarId = null;
    const matchId = null;
    const companyId = null;
    const propertyId = null;
    const tournamentId = null;

    // Objects
    const gimmickRestriction = null;
    const graphic = null;

    return {
        name,
        rank,
        gender,
        prestige,
        highestPrestige,
        brandName,
        monthsToExpire,
        xp,
        xpGainedThisYear,
        booked,
        tagTeam,
        trio,
        championshipContract,
        matchContract,
        vacated,
        retired,
        superstarId,
        matchId,
        companyId,
        propertyId,
        tournamentId,
        gimmickRestriction,
        graphic,
        objectName,
    };
}

function getChampionshipSuperstar(championship) {
    if (championship.superstarId) {
        return Superstars.find({'$loki': championship.superstarId})[0];
    }
    else {
        return null;
    }
}

function getChampionshipMatch(championship) {
    return Matches.find({'$loki': championship.matchId})[0];
}

function getChampionshipCompany(championship) {
    return Companies.find({'$loki': championship.companyId})[0];
}

function addChampionshipChampionshipReigns(championship, championshipReigns) {
    championshipReigns.forEach(c => {
        c.championshipId = championship.$loki
    });
}

function removeChampionshipChampionshipReigns(championship, championshipReigns) {
    championshipReigns.forEach(c => {
        c.championshipId = null
    });
}

function getChampionshipChampionshipReigns(championship) {
    return ChampionshipReigns.find({'championshipId': championship.$loki});
}

function getChampionshipCurrentReign(championship) {
    return ChampionshipReigns.find({'championshipId': championship.$loki}).reverse()[0];
}

function getChampionshipProperty(championship) {
    return Properties.find({'$loki': championship.propertyId})[0];
}

function addChampionshipMatchContracts(championship, matchContracts) {
    matchContracts.forEach(c => {
        c.championshipId = championship.$loki
    });
}

function removeChampionshipMatchContracts(championship, matchContracts) {
    matchContracts.forEach(c => {
        c.championshipId = null
    });
}

function getChampionshipMatchContracts(championship) {
    return MatchContracts.find({'championshipId': championship.$loki});
}

function getChampionshipMatchContract(championship) {
    return MatchContracts.find({'championshipId': championship.$loki})[0];
}

function getChampionshipTournament(championship) {
    return Tournaments.find({'$loki': championship.tournamentId})[0];
}

function addChampionshipRandomEvents(championship, randomEvents) {
    randomEvents.forEach(c => {
        c.championshipId = championship.$loki
    });
}

function removeChampionshipRandomEvents(championship, randomEvents) {
    randomEvents.forEach(c => {
        c.championshipId = null
    });
}

function getChampionshipRandomEvents(championship) {
    return RandomEvents.find({'championshipId': championship.$loki});
}

export { Championship, getChampionshipSuperstar, getChampionshipMatch, getChampionshipCompany,
    addChampionshipChampionshipReigns, removeChampionshipChampionshipReigns, getChampionshipChampionshipReigns,
    getChampionshipProperty, addChampionshipMatchContracts, removeChampionshipMatchContracts,
    getChampionshipMatchContracts, getChampionshipTournament, addChampionshipRandomEvents,
    removeChampionshipRandomEvents, getChampionshipRandomEvents, getChampionshipCurrentReign,
    getChampionshipMatchContract };